// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1AiFd","right":"Footer_right__yTeOf","buttons":"Footer_buttons__5hV21"};